// extracted by mini-css-extract-plugin
export default {"bgScreen":"styles_bgScreen__ipip1","bgForm":"styles_bgForm__6bdV2","wrongCredentials":"styles_wrongCredentials__-lw4V","spinner":"styles_spinner__NjbBn","spin":"styles_spin__F2VLt"};